var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-day",
    transform: "translate(-386.000000, -6.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(25.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 7,
    transform: "translate(362.499429, 12.499429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4814811,1.0658141e-14 C17.3485996,1.0658141e-14 19.9181703,1.56384923 21.2708965,3.97139323 C18.9023155,4.98297341 17.1947732,7.23324591 16.9696329,9.90342583 L16.9696329,9.90342583 L16.5602889,9.90342583 C13.928092,9.90342583 11.7955048,12.0276163 11.7955048,14.6480177 C11.7955048,15.9036168 12.2851145,17.0451014 13.0845548,17.8936376 L4.69850941,17.893181 C2.10319848,17.893181 6.39488462e-14,15.7901824 6.39488462e-14,13.1949714 C6.39488462e-14,10.672044 1.98788247,8.61398575 4.4833993,8.50159588 L4.69850941,8.4967619 L6.60968107,8.4967619 L6.72513707,7.12278552 C7.06200869,3.11111436 10.4288256,1.0658141e-14 14.4814811,1.0658141e-14 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0812227,4.89813333 C26.4911043,4.89813333 28.609597,6.41535512 29.3985963,8.63710842 L29.3985963,8.63710842 L29.8145378,9.80846202 L31.0427697,9.61683505 C31.2579877,9.58324785 31.4771042,9.56625432 31.6990196,9.56625432 C34.0130377,9.56625432 35.8863238,11.4316434 35.8863238,13.7297676 C35.8863238,16.0276919 34.0130377,17.893181 31.6990196,17.893181 L31.6990196,17.893181 L16.5602889,17.893181 C14.7552768,17.893181 13.2949333,16.439235 13.2949333,14.6480177 C13.2949333,12.8569003 14.7549769,11.4028544 16.5602889,11.4028544 L16.5602889,11.4028544 L18.3478077,11.4028544 L18.4637635,10.0293778 C18.7072707,7.14097859 21.1446418,4.89813333 24.0812227,4.89813333 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.feb913d763e83e537c22c8caabb8ee93.svg";
export { ForwardRef as ReactComponent };